import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const powerLineDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "power-line-detect-example",
  version: 1,
  title: "Utility inspection",
  description: "Locate grid hardware",
  subdescription: "Pinpoint insulators, transformers, and arrestors on a power pole.",
  thumbnailUuid: BASE_ASSETS.powerPoleWiresExample.uuid,
  assets: [BASE_ASSETS.powerPoleWiresExample],
  detect: {
    mediaUuid: BASE_ASSETS.powerPoleWiresExample.uuid,
    categories: ["insulators", "transformers", "arrestors"],
    config: {
      output: "point",
      enableThinking: true,
    },
  },
};
